import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import TopBar from '../components/TopBar';
import Api from '../utils/Api';
import RatingsHistory from '../components/RatingsHistoryChartComponent';
import LoadingSpinner from '../components/LoadingSpinner';
import ErrorAlert from '../components/ErrorAlert';
import * as colors from '../utils/Theme';

import '../style/Dashboard.css';

// Dashboard Component
class Dashboard extends Component {
    constructor() {
        super();
        this.state = {
          endDate: moment(),
          startDate: moment().subtract(30, 'days'),
          ratingsHistory: null,
          averageHistory: null,
          avg3: null,
          ratings: null,
          place: null,
          labels: [],
        };
        this.refresh = this.refresh.bind(this);
        this.userRefresh = this.userRefresh.bind(this);
    }

    userRefresh() {
        this.setState({
        ratingsHistory: null,
        averageHistory: null,
        avg3: null,
        ratings: null,
        });
        this.refresh();
    }

    refresh() {

        Api.getUserRatingsHistory(this.state.startDate.format('YMMDD'), this.state.endDate.format('YMMDD')).then(
        res => {
            this.setState({ ratingsHistory: res, ratingsHistoryError: null });
        }
        ).catch(err => {
            if (err.status === 403 || err.status === 401) {
                this.setState({ logout: true });
            }
            if (err.response && err.response.statusText)
            this.setState({ ratingsHistoryError: err.response.statusText });
        });

        Api.getUserAvg3().then(
        res => {
            this.setState({ avg3: res, avg3Error: null });
        }
        ).catch(err => {
        if (err.response && err.response.statusText)
            this.setState({ avg3Error: err.response.statusText });
        });

        Api.getUserEmails().then(
        res => {
            this.setState({ emails: res.emailsCount, emailsError: null });
        }
        ).catch(err => {
        if (err.response && err.response.statusText)
            this.setState({ emailsError: err.response.statusText });
        });

        Api.getUserEmailsHistory(this.state.startDate.format('YMMDD'), this.state.endDate.format('YMMDD')).then(
        res => {
            this.setState({ emailsHistory: res, emailsHistoryError: null });
        }
        ).catch(err => {
        if (err.response && err.response.statusText)
            this.setState({ emailsHistoryError: err.response.statusText });
        });
    
    }

    componentDidMount() {
        this.refresh();
    }

    render() {
        if (this.state.logout)
            return <Redirect to="/login" />

        const averageBlock = this.state.avg3 && (
            <div className="row">
                <div className="col-md-6 col-lg-6">
                    <div className="card card-average">
                        <div className="title">
                            Total Emails Clients
                        </div>
                        <div className="value text-gradient-green-blue">
                            {this.state.emails}
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-6">
                    <div className="card card-average">
                        <div className="title">
                            Total Notes
                        </div>
                        <div className="value text-gradient-red-orange">
                            {this.state.avg3.count}
                        </div>
                    </div>
                </div>

            </div>
        );
          

        return(
            <div className="route-wrapper">
                <TopBar
                    title="Accueil"
                    subheading="Données globales de vos établissements"
                    icon="pe-7s-rocket"
                />
                <div className="app-inner-layout">
                    <div className="app-inner-layout-content">
                        <div className="container-fluid">
                            {
                                this.state.avg3
                                ? averageBlock
                                : (this.state.avg3Error ? <ErrorAlert message={this.state.avg3Error}/> : <LoadingSpinner />)
                            }

                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header">
                                            <i className="pe-7s-graph3 header-icon gradient-icon-green-blue"></i>
                                            Nombres total d'emails clients
                                        </div>
                                        <div className="card-body">
                                            {
                                                this.state.emailsHistory ?
                                                <RatingsHistory
                                                data={[
                                                    {
                                                    key: "Nombre d'emails",
                                                    values: this.state.emailsHistory,
                                                    color: colors.rating2,
                                                    }
                                                ]}
                                                /> :
                                                (this.state.emailsHistoryError ? <ErrorAlert message={this.state.emailsHistoryError}/> : <LoadingSpinner />)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header">
                                            <i className="pe-7s-graph3 header-icon gradient-icon-red-orange"></i>
                                            Nombres total de notes
                                        </div>
                                        <div className="card-body">
                                            {
                                                this.state.ratingsHistory ?
                                                <RatingsHistory
                                                data={[
                                                    {
                                                    key: "Nombre de notes",
                                                    values: this.state.ratingsHistory,
                                                    color: colors.rating1,
                                                    }
                                                ]}
                                                /> :
                                                (this.state.ratingsHistoryError ? <ErrorAlert message={this.state.ratingsHistoryError}/> : <LoadingSpinner />)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </div>
        );
    }
}
export default Dashboard;



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js